import { FC } from 'react';
import heroImage from '@assets/dashboard/welcome-hero.png';

interface HeroProps {
  title: string;
  subtitle: string;
}

export const Hero: FC<HeroProps> = ({ title, subtitle }) => {
  return (
    <section className="relative flex flex-col overflow-hidden rounded-[26px] bg-[#f69b47] shadow-[0_0_4px_rgba(0,0,0,0.25)] lg:flex-row lg:items-center lg:justify-between lg:p-11">
      <img
        src={heroImage}
        alt=""
        aria-hidden
        className="h-44 w-full object-cover object-[center_65%] lg:absolute lg:inset-y-0 lg:right-0 lg:h-full lg:w-1/2"
      />
      <div
        aria-hidden
        className="absolute top-0 right-0 hidden h-full w-1/2 bg-linear-to-r from-[#f69b47] via-[#f69b47]/20 to-transparent lg:block"
      />
      <div className="relative z-10 flex flex-col gap-2 px-6 py-6 text-(--tertiary-Y100) lg:max-w-lg lg:gap-7 lg:p-0">
        <p className="bold m-0! [font-family:var(--font-montserrat)] text-[10px] tracking-[1.8px] uppercase">
          Your newlane journey
        </p>
        <h1 className="m-0! text-2xl! bold text-(--neutral-white-NW1000)! lg:[font-size:var(--fs-h1)]!">
          {title}
        </h1>
        <p className="[font-size:var(--fs-p4)]! m-0! lg:[font-size:var(--fs-p3)]!">{subtitle}</p>
      </div>
    </section>
  );
};
